"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiGroup = _interopRequireDefault(require("./ApiGroup"));
class Users extends _ApiGroup.default {
  /**
   * Creates a new API Miner user.
   */
  create(id, name) {
    let data = {
      auth: true,
      account: true
    };
    if (id) {
      data.externalId = id;
    }
    if (name) {
      data.name = name;
    }
    return this.request({
      method: 'post',
      url: '/users',
      data
    }).then(response => response.data);
  }

  /**
   * Get a specific Account by its ID.
   */
  get(id) {
    return this.request({
      url: `/accounts/${id}`
    }).then(response => response.data.data);
  }
}
var _default = exports.default = Users;
//# sourceMappingURL=Users.js.map